<template>
  <div class="app-shell">
    <PortalHeader />
    <main class="app-main">
      <RouterView />
    </main>
    <PortalFooter />
  </div>
</template>

<script>
import PortalHeader from './components/PortalHeader.vue';
import PortalFooter from './components/PortalFooter.vue';

export default {
  name: 'App',
  components: {
    PortalFooter,
    PortalHeader,
  },
};
</script>
